var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.$rules.email}})],1)],1),_c('v-card-actions',{staticClass:"d-flex justify-center"},[_c('v-btn',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Voltar ")]),_c('v-btn',{staticClass:"secondary"},[_vm._v(" Enviar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }